import $api from '../../utils/api.js'
import moment from 'moment'

const state = () => ({
    sorting_type:[
        {value:'6m',label:'the last 6 months'},
        {value:'3m',label:'the last 3 months'},
        {value:'1m',label:'the last 1 months'},
        {value:'2w',label:'the last 2 weeks'},
        {value:'1w',label:'the last 1 weeks'},
        {value:'custom',label:'Custom Date'},
    ],
    type_chart:[
        {label:"Daily",value:"DAY"},
        {label:"monthly",value:"MONTH"},
        {label:"Yearly",value:"YEAR"}
    ],
    sorting_report:{
        date_type:'6m',
        chart_type:'DAY',
        start_date:moment().format('YYYY-MM-DD'),
        end_date:moment().format('YYYY-MM-DD'),
    },
    reports:{},
    historys:[],
    leaderboard:{},
    participant_rank:[]
})

const mutations = {
    ASSIGN_REPORTS(state, payload) {
        state.reports = payload
    },
    ASSIGN_DATA_HISTORYS(state, payload) {
        state.historys = payload
    },
    ASSIGN_DATA_LEADERBOARD(state, payload) {
        state.leaderboard = payload
    },
    ASSIGN_DATA_PARTICIPANT_RANK(state, payload) {
        state.participant_rank = Object.values(payload)
    },
    CLEAR_HISTORYS(state){
        state.historys = []
    },
    CLEAR_SORTING_REPORT(state){
        state.sorting_report = {
            date_type:'6m',
            chart_type:'DAY',
            start_date:moment().format('YYYY-MM-DD'),
            end_date:moment().format('YYYY-MM-DD'),
        }
    }
}

const actions = {
    getReportsAdmin({ commit, state }) {
        return new Promise((resolve) => {
            $api.get(`reports/admin?date_type=${state.sorting_report.date_type}&start_date=${state.sorting_report.start_date}&end_date=${state.sorting_report.end_date}&chart=${state.sorting_report.chart_type}`)
            .then((response) => {
                commit('ASSIGN_REPORTS', response.data)
                resolve(response.data)
            })
        })
    },
    getReportsDistributor({ commit, state }) {
        return new Promise((resolve) => {
            $api.get(`reports/distributor?date_type=${state.sorting_report.date_type}&start_date=${state.sorting_report.start_date}&end_date=${state.sorting_report.end_date}&chart=${state.sorting_report.chart_type}`)
            .then((response) => {
                commit('ASSIGN_REPORTS', response.data)
                resolve(response.data)
            })
        })
    },
    getReportsAgent({ commit, state }) {
        return new Promise((resolve) => {
            $api.get(`reports/agent?date_type=${state.sorting_report.date_type}&start_date=${state.sorting_report.start_date}&end_date=${state.sorting_report.end_date}&chart=${state.sorting_report.chart_type}`)
            .then((response) => {
                commit('ASSIGN_REPORTS', response.data)
                resolve(response.data)
            })
        })
    },
    getLeaderboardAgent({ commit }) {
        return new Promise((resolve) => {
            $api.get(`reports/leaderboard`)
            .then((response) => {
                commit('ASSIGN_DATA_LEADERBOARD', response.data)
                resolve(response.data)
            })
        })
    },
    getParticipantRank({ commit }, payload) {
        return new Promise((resolve) => {
            $api.get(`participant-rank-agent?id=${payload.id}&start=${payload.start_date}&end=${payload.end_date}`)
            .then((response) => {
                commit('ASSIGN_DATA_PARTICIPANT_RANK', response.data)
                resolve(response.data)
            })
        })
    },
    getHistorys({ commit, state }) {
        return new Promise((resolve) => {
            $api.get(`historys?date_type=${state.sorting_report.date_type}&start_date=${state.sorting_report.start_date}&end_date=${state.sorting_report.end_date}`)
            .then((response) => {
                commit('ASSIGN_DATA_HISTORYS', response.data)
                resolve(response.data)
            })
        })
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}